module.exports = __webpack_public_path__ + "fonts/arrow-green-up.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/assets/img/arrow-green-up.svg
// module id = 1292
// module chunks = 2